var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popit-prize",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":require("@/assets/svg/prize.svg")}}),_c('p',{staticClass:"text"},[_vm._v("ура! подарок!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }